import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1231 23.0001H7.37685C5.51143 23.0001 4 21.502 4 19.6531V4.34941C4 2.5005 5.51143 1.00244 7.37685 1.00244H15.8423L20.5 5.63972V19.6531C20.5 21.502 18.9886 23.0001 17.1231 23.0001Z",
			fill: "#596C89"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 5.63972H16.7994C16.2755 5.63972 15.8493 5.21962 15.8493 4.70026L15.8423 1.00244",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9975 1H10.9146V2.07334H11.9975V1Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.078 2.07349H11.9951V3.14683H13.078V2.07349Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9975 3.14673H10.9146V4.22006H11.9975V3.14673Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.078 4.21997H11.9951V5.29331H13.078V4.21997Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9975 5.29102H10.9146V6.36435H11.9975V5.29102Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.078 6.3645H11.9951V7.43784H13.078V6.3645Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9975 7.43774H10.9146V8.51108H11.9975V7.43774Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.078 8.51099H11.9951V9.58432H13.078V8.51099Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9975 9.58203H10.9146V10.6554H11.9975V9.58203Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.078 10.6555H11.9951V11.7289H13.078V10.6555Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0804 11.7288H10.9146V14.7203H13.0804V11.7288Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5375 13.2246H11.4546V14.2979H12.5375V13.2246Z",
			fill: "#A1BEDF"
		})
	]
});
export default SvgZip;
